import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  value: boolean;
  size?: string | null;
  disabled?: boolean | 'true' | 'false' | null;
}

/** `InputCheckbox` component emits. */
export type Emits = (event: 'input', value: boolean) => void;


import { computed } from 'vue';

import { faCheck } from '@icons/solid/faCheck';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    InputCheckbox: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'InputCheckbox' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: { type: Boolean },
    size: { default: null },
    disabled: { type: [Boolean, String, null], default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((event: 'input', value: boolean) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, size: string | null, disabled: boolean | 'true' | 'false' | null };

/**
 * `InputCheckbox` component properties.
 */




const inputDisabled = computed(() => {
  return props.disabled !== false && props.disabled !== 'false';
});

const classList = computed(() => {
  const classList: string[] = [];

  if (props.value) {
    classList.push('checked');
  }

  if (inputDisabled.value) {
    classList.push('disabled');
  }

  if (props.size === 'sm') {
    classList.push('size-small');
  }

  return classList;
});

function toggle() {
  if (inputDisabled.value) return;

  emit('input', !props.value);
}

return { __sfc: true,props, emit, inputDisabled, classList, toggle, faCheck }
}

})